import React, {Component, Fragment}  from 'react'
import { connect } from 'react-redux'
import classes from './Layout.module.scss';
import { NavLink, withRouter } from 'react-router-dom';

import {  doLogout } from '../../redux/auth/actions';

import { slide as Menu } from 'react-burger-menu'
import Media from 'react-media';

import Toolbar from './Toolbar/Toolbar'

import moment from 'moment';

class Layout extends Component {

    state = {
        now :  moment(),
        height:0,
        menuOpen:false
    }

    constructor(props) {
        super(props)
      }

    componentDidMount(){
        const height = (this.alertDiv ? this.alertDiv.clientHeight: 0);
        this.setState({ height });
        this.refresh = setInterval(()=>{
            this.setState({
                now :  moment()
            })
        }, 3000);
        window.addEventListener('resize', ()=>{
            const height = (this.alertDiv ? this.alertDiv.clientHeight: 0);
            this.setState({ height });
        });
    }

    componentDidUpdate(prevProps) {
        if (this.props.match.params.userId !== prevProps.match.params.userId) {
            const height = (this.alertDiv ? this.alertDiv.clientHeight: 0);
            this.setState({ height });
        }
    }

    openMenu = () =>{
        console.log("test");
        this.setState({
            menuOpen:true
        });
    }

    closeMenu = () =>{
        this.setState({
            menuOpen:false
        });
    }

    isMenuOpen = (state) => {
        this.setState({
            menuOpen:state.isOpen
        });
    };
    
    render(){
        const expirationdate = moment.unix(this.props.expiration);
        const expirationdatebefore = moment.unix(this.props.expiration).subtract(7, 'days');
        const displaybanner = (expirationdatebefore < this.state.now && this.props.location.pathname!='/account/');
        const accountdisabled = expirationdate<=this.state.now;
        let message = `${this.props.termes.application.membreBannerTextWillExpire} ${expirationdate.fromNow()}`;
        let btnText = ( window.innerWidth <= 750 ? this.props.termes.application.membreBannerBTNWillExpireShort : this.props.termes.application.membreBannerBTNWillExpire);
        if(accountdisabled){
            message = `${this.props.termes.application.membreBannerTextHasExpired} ${expirationdate.fromNow()}`;
            btnText = this.props.termes.application.membreBannerBTNHasExpired;
        }
        const styles = {
            bmBurgerButton: {
                top: displaybanner ? (this.state.height + 36 )+'px':'36px'
            }
        }
       
        return(
            <Fragment>
             <Media query={{ maxWidth: 751 }}>
       
                    { matches => (  <Fragment> { matches ? 
                    <Menu  onStateChange={ this.isMenuOpen }  isOpen={this.state.menuOpen} styles={styles} customBurgerIcon={ false }>
                        <NavLink onClick={() => this.closeMenu()} exact to="/">Dashboard</NavLink>
                        <NavLink onClick={() => this.closeMenu()} to="/marks/">Marks</NavLink>
                        <NavLink onClick={() => this.closeMenu()} to="/jewels/">Jewelry database</NavLink>
                        <NavLink onClick={() => this.closeMenu()}  to="/contact/">Contact</NavLink>
                        <NavLink onClick={() => this.closeMenu()} to="/account/"> <img alt="" src={require('../../assets/img/account.svg')}  /> Your account</NavLink>
                        <button  onClick={()=> {  this.props.history.push('/login'); this.props.doLogout(); } }>Logout</button>
                    </Menu> : null }  </Fragment>)}
                    
                </Media>
            { displaybanner ? <div ref={ (alertDiv) => { this.alertDiv = alertDiv } } className={classes.Alert}><div className={classes.inside}><div style={{marginRight : "10px"} }>{ message }</div> <NavLink className="buttonbig inverted"  to="/account/">{ btnText }</NavLink></div></div>: null }
                <Toolbar burgerClick={ () => this.openMenu() } burgerActive={ this.state.menuOpen } />
                <main className={classes.Content}>
                    {this.props.children}
                </main>
                <footer className={classes.Footer}><div className={classes.inside}>© 2020 ResearchJewel - <a href="/en/disclaimer" target="_blank">Disclaimer</a> - <a href="/en/gsc"  target="_blank">GSC</a></div></footer>
            </Fragment>
        );
    } 
}

const mapStateToProps = (state)=>{
    return {
      expiration:state.auth.userinfos.expirationtimestamp,
      termes: state.settings.termes
    }
  };
  
  
  export default connect(mapStateToProps, {doLogout} )(withRouter(Layout));